import React from 'react';
import { FaDownload, FaDiscord } from 'react-icons/fa';
import './Dashboard.css';

const Dashboard = ({ productKey, keyStatus, expiryValue, downloadLink }) => {
  // Farbe für den Status: "activated" grün, sonst orange
  const statusColor = keyStatus === "activated" ? "green" : "orange";

  let expiryDisplay = null;
  if (keyStatus === "activated") {
    // Gesamtsekunden in Tage, Stunden, Minuten und Sekunden umrechnen
    const totalSeconds = parseInt(expiryValue, 10);
    const days = Math.floor(totalSeconds / (3600 * 24));
    let remainder = totalSeconds % (3600 * 24);
    const hours = Math.floor(remainder / 3600);
    remainder = remainder % 3600;
    const minutes = Math.floor(remainder / 60);
    const seconds = remainder % 60;

    expiryDisplay = (
      <p>
        <span style={{ fontWeight: 'bold' }}>Expires in:</span>{' '}
        <span className="highlight-green">{days}</span>{' '}
        <span style={{ color: 'white' }}>day(s)</span>{' '}
        <span className="highlight-green">{hours}</span>{' '}
        <span style={{ color: 'white' }}>hour(s)</span>{' '}
        <span className="highlight-green">{minutes}</span>{' '}
        <span style={{ color: 'white' }}>minute(s)</span>{' '}
        <span className="highlight-green">{seconds}</span>{' '}
        <span style={{ color: 'white' }}>second(s)</span>
      </p>
    );
  } else {
    expiryDisplay = (
      <p style={{ color: 'white' }}>
        Your key is valid for{' '}
        <span className="highlight-green">{expiryValue}</span>{' '}
        <span style={{ color: 'white' }}>day(s)</span> after activation. Please download your script build and activate the key in the script software.
      </p>
    );
  }

  return (
    <div className="dashboard-page">
      <div className="dashboard-container">
        <h1>Welcome to your Dashboard</h1>

        <p>
          <span style={{ fontWeight: 'bold' }}>Your key:</span>{' '}
          <span className="highlight-green">{productKey}</span>
        </p>

        <p>
          <span style={{ fontWeight: 'bold' }}>Status:</span>{' '}
          <span style={{ color: statusColor }}>{keyStatus}</span>
        </p>

        {expiryDisplay}

        <div className="dashboard-buttons">
          <a
            href={downloadLink}
            target="_blank"
            rel="noopener noreferrer"
            className="dashboard-button download-button"
          >
            <FaDownload className="icon" />
            <span>Download Script</span>
          </a>
          <a
            href="https://eaglescript.space:5989/"
            target="_blank"
            rel="noopener noreferrer"
            className="dashboard-button support-button"
          >
            <FaDiscord className="icon" />
            <span>Discord Support</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
